import(/* webpackMode: "eager" */ "/workspace/pkgs/apps/a-hdc/src/app/(fullPage)/(postMain)/article/labels/[id]/error.tsx");
